import { Component, OnInit, ViewEncapsulation  } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { FlowService } from './services/flow.service';
import { IconService } from './services/icon.service';
import { RemoteConfigService, isVersionOlderThan } from './services/remote-config.service';

// package.json's `version` field, injected at build time. `resolveJsonModule`
// is on, but a plain `import` of package.json triggers a webpack
// ESM/CommonJS interop warning-as-error under this app's build config, so a
// `require()` (also handled by webpack) is used instead - no new tooling
// dependency needed.
declare const require: (id: string) => { version: string };
const appVersion: string = require('../../package.json').version;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit
{
    maintenanceMode = false;

    constructor(
        flow: FlowService,
        iconService: IconService,
        private remoteConfig: RemoteConfigService,
        private snackBar: MatSnackBar,
    )
    {
        flow.register();
        iconService.connectIcons();
    }

    ngOnInit(): void {
        // Both builds: consult Remote Config once it's settled (fetched or
        // fallen back to bundled defaults) for maintenance mode and the
        // minimum supported version stale-tab check.
        this.remoteConfig.whenReady().finally(() => {
            this.maintenanceMode = this.remoteConfig.maintenanceMode;
            if (!this.maintenanceMode) {
                this.checkStaleVersion();
            }
        });
    }

    private checkStaleVersion(): void {
        const minSupportedVersion = this.remoteConfig.minSupportedVersion;
        if (isVersionOlderThan(appVersion, minSupportedVersion)) {
            this.snackBar.open('A new version is available, please reload.', 'Reload', {
                panelClass: 'snackbar-error',
            }).onAction().subscribe(() => window.location.reload());
        }
    }
}
